import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import { TextareaField } from '../../../../utils/InputField';

function ModalAgencyCustomerStatusChange({ data, onReload }) {
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { setMessage, setConfirm } = useTemplate();
    const { put } = useApi();
    const [formData, setFormData] = useState({
        Id: data?.id,
        Status: data?.status === 'active' ? 'inactive' : 'active',
        Note: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    const handleCustomerStatusUpdate = (e) => {
        setLoading(true);
        e.preventDefault();
        put(`/api/customers/${formData.Id}/status`, formData)
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                setMessage({ type: 'success', text: message });
                onReload();
                setConfirm(null);
            })
            .catch((ex) => {
                setMessage({ type: 'error', text: ex?.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleCustomerStatusUpdate} className="w-full flex flex-col gap-2">
            <p className="text-base font-normal">
                Are you sure you want to{' '}
                <span className="text-error font-medium">{formData?.Status}</span> this customer??
            </p>
            <TextareaField
                name="Note"
                placeholder="Write your notes....."
                formData={formData}
                onChange={handleChange}
                className="h-20 *:resize-none"
            />
            <p className="text-error text-xs text-left ">This field is required.</p>
            <div className="w-full flex justify-end items-center gap-2">
                <ButtonCancel title="Cancel" onClick={() => setConfirm(null)} />
                <ButtonPrimary
                    title="Save"
                    btnType="submit"
                    className={{ 'bg-error': data?.status === 'active' }}
                    loading={loading}
                />
            </div>
        </form>
    );
}

export default ModalAgencyCustomerStatusChange;
